import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssueFieldsManagementRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-fields-management-view',
	path: '/jira/settings/issues/fields',
};
